export enum QualityLabel {
  DEFINITION,
  HEIGHT,
  BITRATE,
  CUSTOM,
}
